import { Button } from '@bpinternal/ui-kit-next'
import { useSuspenseQuery } from '@tanstack/react-query'
import { Newspaper } from 'lucide-react'
import { userPreferencesQueryOptions } from '~/queries'
import { ANNOUNCEMENTS } from '../types'
import { AnnouncementPopover } from './AnnouncementPopover'
import { useAppStore } from '~/stores'

export function AnnouncementsButton({ workspaceId }: { workspaceId: string }) {
  const { data: recentBots } = useSuspenseQuery(
    userPreferencesQueryOptions({ path: '$workspaceId/botHistory', params: { workspaceId } })
  )
  const { data: seenAnnouncementIds } = useSuspenseQuery(userPreferencesQueryOptions({ path: 'seenAnnouncementIds' }))
  const currentUser = useAppStore((state) => state.currentUser)

  const userCreatedAt = currentUser?.createdAt ? new Date(currentUser.createdAt).getTime() : 0

  const activeAnnouncements = ANNOUNCEMENTS.filter((a) => {
    const expirationDate = new Date(a.releaseDate)
    expirationDate.setDate(expirationDate.getDate() + a.daysActive)
    const announcementReleaseTime = new Date(a.releaseDate).getTime()

    return (
      Date.now() > announcementReleaseTime &&
      Date.now() < expirationDate.getTime() &&
      announcementReleaseTime >= userCreatedAt
    )
  })
  const unseenAnnouncements = activeAnnouncements.filter((a) => !seenAnnouncementIds.includes(a.id))

  if (!recentBots[0] || activeAnnouncements.length === 0) return

  return (
    <AnnouncementPopover announcements={activeAnnouncements} workspaceId={workspaceId} botId={recentBots[0]}>
      <Button variant="ghost" size="icon" className="relative h-7 w-7 sm:h-8 sm:w-8">
        <Newspaper className="!h-4 !w-4 text-foreground sm:!h-5 sm:!w-5" />
        {unseenAnnouncements.length > 0 && (
          <div className="absolute right-0.5 top-0.5 size-2 rounded-full bg-red-500"></div>
        )}
      </Button>
    </AnnouncementPopover>
  )
}
